<ig-row>
  <ig-col [xs]="12">
    <div [class.selector-disabled]="disabled" class="select-img-box" [class.small]="isSmallIcon">
      <img
        class="preview-img"
        *ngIf="selectedImageData"
        [src]="safeImage()"
        (click)="imageSelector.click()"
      />
      <input
        type="file"
        [disabled]="disabled"
        accept="image/png,image/gif,image/jpeg"
        #imageSelector
        (change)="onImageChange($event)"
      />
      <ig-success-wrap class="image-success" #upload [delay]="100" text="Upload succeed!">
        <mat-icon
          *ngIf="
            selectedImageData &&
            isSmallIcon &&
            command.image &&
            !isShowUploadingSpinner &&
            isShowUploadIcon
          "
          class="image-edit"
          (click)="updateImage()"
          matTooltip="update image"
          >check</mat-icon
        >
        <!--                <mat-icon *ngIf="isSmallIcon" matTooltip="change image" [class.image-close]="isSmallIcon" (click)="clearImage()">close</mat-icon>-->
        <ig-spinner *ngIf="isShowUploadingSpinner" class="image-spinner"></ig-spinner>
      </ig-success-wrap>
      <ng-container *ngIf="!isSimple">
        <mat-icon
          *ngIf="isSmallIcon"
          matTooltip="change image"
          [class.image-close]="isSmallIcon"
          (click)="clearImage()"
          >close</mat-icon
        >
        <div
          class="img-text"
          [class.small-text]="isSmallIcon && selectedImageData"
          [class.img-text-update]="selectedImageData"
          (click)="imageSelector.click()"
        >
          <mat-icon *ngIf="!selectedImageData">photo</mat-icon>
          <h1 *ngIf="!selectedImageData">{{ label }}</h1>
          <!--                    <h1 *ngIf="!selectedImageData">PHOTO SIZE 2MB MAXIMUM</h1>-->
          <h1 *ngIf="selectedImageData && !isSmallIcon">{{ updateLabel }}</h1>
          <h4 *ngIf="label2">{{ label2 }}</h4>
        </div>
      </ng-container>
      <ng-container *ngIf="isSimple">
        <div
          class="simple-upload-icon-wrap"
          (click)="imageSelector.click()"
          matTooltip="upload an image"
        >
          <mat-icon class="vertical-middle">add</mat-icon>
        </div>
      </ng-container>
    </div>
  </ig-col>
</ig-row>



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/image.selector/image.selector.component.html